<template>
  <div>
    <vs-card class="border_primary mb-0">
      <div class="col-span-12 my-5">
        <div>
          <div v-for="(item, index) in detail" :key="index">
            <div v-if="item.isShow">
              <div v-if="item.type == 'Image'">
                <imagePage :imageData="item" />
              </div>
              <div v-if="item.type == 'String'">
                <div>
                  <stringPage :stringData="item"></stringPage>
                </div>
              </div>
              <div v-if="item.type == 'Link'">
                <linkPage :linkData="item"></linkPage>
              </div>
              <div v-if="item.type === 'Number'">
                <numberPage :numberData="item" />
              </div>
              <div v-if="item.type === 'Float'">
                <floatPage :floatData="item" />
              </div>

              <div v-if="item.type === 'Object'">
                <objectPage :objectData="item" />
              </div>
              <div v-if="item.type === 'Array'">
                <arrayPage :arrayData="item" />
              </div>
              <div v-if="item.type === 'ArrayObject'">
                <arrayObjectPage :arrayObjectData="item" />
              </div>
              <div v-if="item.type === 'Date'">
                <datePage :dateData="item" />
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import imagePage from "./../pageComponent/imagePage/imagePage";
import stringPage from "./../pageComponent/stringPage/stringPage";
import floatPage from "./../pageComponent/floatPage/floatPage";
import numberPage from "./../pageComponent/numberPage/numberPage";
import objectPage from "./../pageComponent/objectPage/objectPage";
import arrayPage from "./../pageComponent/arrayPage/arrayPage";
import arrayObjectPage from "./../pageComponent/arrayObjectPage/arrayObjectPage";
import linkPage from "./../pageComponent/linkPage/linkPage";
import datePage from "./../pageComponent/datePage/datePage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      detail: "general/detailData"
    })
  },
  mounted() {},
  components: {
    imagePage,
    stringPage,
    floatPage,
    numberPage,
    objectPage,
    arrayPage,
    arrayObjectPage,
    linkPage,
    datePage
  }
};
</script>

<style lang="scss"></style>
